import { render, staticRenderFns } from "./V2FilterWrapper.vue?vue&type=template&id=25908e98&scoped=true&"
import script from "./V2FilterWrapper.vue?vue&type=script&lang=js&"
export * from "./V2FilterWrapper.vue?vue&type=script&lang=js&"
import style0 from "./V2FilterWrapper.vue?vue&type=style&index=0&id=25908e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25908e98",
  null
  
)

export default component.exports